import { gql } from '@apollo/client';

export const GET_WELD = gql`
  query GetWeld($weldId: ID!) {
    weld(weld_id: $weldId) {
      id
      length
      no
      project {
        id
      }
      status
      weld_joint_type {
        weld_type {
          id
          name
        }
        joint_type {
          id
          name
        }
      }
      wps {
        id
        no
        welder_certification_standards
      }
      welding_progress
      welder {
        date
      }
      logs {
        type
        date
      }
      inspections
      inspection_groups
      inspection_category {
        name
        hold_time
        inspections {
          double_length
          company_id
          range
          type_id
        }
      }
    }
  }
`;
